// https://github.com/ankurk91/vue-toast-notification
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
// Import one of the available themes
// import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast);

Vue.prototype.$error = (msg) => {
    if (typeof (window) != "undefined" && window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler('message_error', msg);
        return;
    }
  Vue.$toast.clear();
  Vue.$toast.open({
    message: msg,
    type: 'error',
    position: 'top',
    duration: 3000,
  });
};

Vue.prototype.$success = (msg) => {
    if (typeof (window) != "undefined" && window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler('message_success', msg);
        return;
    }
  Vue.$toast.clear();
  Vue.$toast.open({
    message: msg,
    type: 'success',
    position: 'top',
    duration: 3000,
  });
};
